/* Alaya - cart drawer / video floater collision guard.
   Mirrors the CSS :has() rules with a class on <html>, for browsers or drawer
   implementations the selectors miss. Only ever toggles one class. */
(function () {
  if (window.__alayaFloaterGuard) { return; }
  window.__alayaFloaterGuard = true;

  var CLASS = 'alaya-drawer-open';
  var queued = false;

  function isOpen(el) {
    if (!el) { return false; }
    if (el.hasAttribute('open')) { return true; }
    if (el.getAttribute('aria-hidden') === 'false') { return true; }
    if (el.classList.contains('is-open')) { return true; }
    if (el.classList.contains('drawer--open')) { return true; }
    return false;
  }

  function apply() {
    queued = false;
    var open = false;
    var els = document.querySelectorAll('#cart-drawer, cart-drawer');
    Array.prototype.forEach.call(els, function (el) {
      if (isOpen(el)) { open = true; }
    });
    document.documentElement.classList.toggle(CLASS, open);
  }

  function schedule() {
    if (queued) { return; }
    queued = true;
    requestAnimationFrame(apply);
  }

  try {
    new MutationObserver(schedule).observe(document.documentElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open', 'aria-hidden', 'class', 'hidden']
    });
  } catch (e) {}

  document.addEventListener('click', schedule, true);
  document.addEventListener('keyup', schedule, true);
  document.documentElement.addEventListener('cart:refresh', schedule);
  document.addEventListener('DOMContentLoaded', apply);

  apply();
})();
